import { refreshReducersToInitial } from "./refreshData-action";
import { ServiceDetailsBreakdown } from "../types";

export const UPDATE_SERVICE_DETAILS = "UPDATE_SERVICE_DETAILS" as const;

type UpdateServiceDetailsPayload = {
  serviceCosts: ServiceDetailsBreakdown[];
  partnerCode: string;
  error?: any;
};

export const updateServiceDetails = (payload: UpdateServiceDetailsPayload) =>
  ({ type: UPDATE_SERVICE_DETAILS, payload } as const);

export type ServiceDetailsActions = ReturnType<typeof updateServiceDetails> | ReturnType<typeof refreshReducersToInitial>;
